import { createContext, useContext } from 'react';
export const ExpandingTextAreaContext = /*#__PURE__*/createContext(undefined);
const {
  Consumer,
  Provider
} = ExpandingTextAreaContext;
export { Consumer as ExpandingTextAreaContextConsumer, Provider as ExpandingTextAreaContextProvider };
export { Consumer };
export const useExpandingTextAreaContext = () => {
  const state = useContext(ExpandingTextAreaContext);
  if (!state) {
    // If the component is not wrapped in ExpandingTextAreaContextProvider, return undefined
    return undefined;
  }
  return state;
};